<template>
<!-- 
    <b-container fluid>
        <b-row>
            <b-col>
                <b-card>
                    <tabs @activate-tab="onTabChange">
                        <tab-pane v-for="t in terminals" :key="'terminal-'+ t.terminalId" :id="t.terminalId.toString()">
                            <span slot="title" class='tab-title'>{{ t.name }}</span>
                            <Terminal :terminal="t" :activeTerminalId="activeTerminalId"></Terminal>
                        </tab-pane>
                    </tabs>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
-->
<b-container fluid class='terminal-view'>
  <Loading v-if="!terminal" />
  <div v-else>
    <b-row>
        <b-col class='text-right'>
            <ul class='terminal-links'>
                <li v-for="t in otherTerminals" :key="'terminal-'+ t.terminalId"><a href="#" @click="setSelectedTerminal(t.terminalId)">{{ t.name }}</a></li>
            </ul>
        </b-col>
    </b-row>
  
    <Terminal :terminal="terminal" :activeTerminalId="terminal.terminalId"></Terminal>
  
  </div>
 </b-container>
</template>

<script>
import terminalView from '@/store/terminals/terminalView';
import Terminal from '@/components/Terminals/Terminal.vue';

export default {
    name: 'TerminalView',
    components: {
		Terminal
	},
    data() {
        return {
            activeTerminalId: null,
            terminal: null
        };
    },
    computed: {
        terminals() {
            return this.$store.state.terminalView.terminalList;
        },
        otherTerminals(){
            return this.terminal ? this.terminals.filter(t => t.terminalId != this.terminal.terminalId) : this.terminals  ;
        }
    },
    watch: {
         /*
        terminals() {
            // Set the actual initial value for activeTerminalId.
            var terminals = this.$store.state.terminalView.terminalList;
            if (this.activeTerminalId == null && terminals.length > 0) {
                this.activeTerminalId = terminals[0].terminalId;
            }
        }
         */
    },
    beforeCreate() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
        this.$store.dispatch('terminalView/getTerminals').finally(() => { 
            var id = this.$route.query.id; 
            if(!id) id = this.terminals[0].terminalId;
            this.setSelectedTerminal(id);
        })
    },
    methods: {
        /*
        onTabChange(selectedTab) {
            this.activeTerminalId = parseInt(selectedTab.id);
            this.$store.commit('terminalView/setSelectedDisplay', {});
        },
        */
        setSelectedTerminal(id){
            this.terminal = this.terminals.find(t => t.terminalId == id);
            var view =  this.$store.state.views.get(this.$route.path);
            this.$store.commit('addViewInfo', { path: view.path, name: this.terminal.name, parent: this.$t('nav.terminals.terminal_view') } );
            this.$store.commit('terminalView/setSelectedDisplay', {});
        }


    },
}

</script>
